/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { AI_METADATA, SHARE_AI_METADATA_LABEL, UNSHARE_AI_METADATA_LABEL } from '@/configs/strings/ai-metadata.strings'
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useToast } from '@chakra-ui/react'
import { useAuth0 } from '@auth0/auth0-react'
import { shareAIMetadata, unshareAIMetadata } from '@/services/ai-metadata'
import { defaultToastConfig } from '@/configs/toast'

const ShareModal = ({
  reloadLicensedAsset,
  aiMetadata,
  onCloseModal
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const toast = useToast()
  const isShared = aiMetadata.state === 'SHARED'
  const onShareAiMetadata = async () => {
    try {
      isShared
        ? await unshareAIMetadata(aiMetadata.id, getAccessToken)
        : await shareAIMetadata(aiMetadata.id, getAccessToken)

      toast({
        title: 'Success',
        description: 'AI Metadata was updated successfully',
        status: 'success',
        ...defaultToastConfig
      })
      onCloseModal()
      reloadLicensedAsset()
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to add AI Metadata. Please try again.',
        status: 'error',
        ...defaultToastConfig
      })
    }
  }
  const modalText = isShared
    ? `Are you sure you want to unshare this ${AI_METADATA}?`
    : `Are you sure you want to share this ${AI_METADATA}?`

  return (
    <Modal isOpen={true} onClose={onCloseModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{ SHARE_AI_METADATA_LABEL }</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          { modalText }
        </ModalBody>
        <ModalFooter>
          <Button variant='ghost' mr={3} onClick={onCloseModal}>
            Cancel
          </Button>
          <Button
            colorScheme={isShared ? 'red' : undefined}
            onClick={() => onShareAiMetadata()}
          >
            { isShared
              ? UNSHARE_AI_METADATA_LABEL
              : SHARE_AI_METADATA_LABEL
            }
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ShareModal
